import { combineReducers, configureStore } from '@reduxjs/toolkit'

import enhancedApi from '../api'

import app from './reducers/AppSlice'
import auth from './reducers/AuthSlice'
import chatAi from './reducers/ChatAiSlice'
import research from '../../pages/advertising-research/model/researchSlice'
import competitors from '../../pages/advertising-research/model/competitorsSlice'
import keywords from '../../pages/advertising-research/model/keywordsSlice'
import adOverview from '../../pages/ad-overview/model/adOverviewSlice'
import advertiserReport from '../../pages/paid-results/model/paidResultsSlice'
import organicResults from '../../pages/organic-results/model/organicResultsSlice'
import positionTracker from '../../pages/position-tracker/model/positionTrackerSlice'
import detailedInfo from '../../pages/domain-overview/model/domainOverviewSlice'
import serpPresence from '../../pages/serp-presence/model/serpPresenceSlice'
import liveSearch from '../../pages/live-search/model/liveSearchSlice'
import liveUncloaking from '../../pages/live-uncloaking/model/liveUncloakingSlice'
import blackhatMonitoring from '../../pages/blackhat-monitoring/model/blackhatMonitoringSlice'
import ppcCompliance from '../../pages/ppc-compliance/model/ppcComplianceSlice'
import projects from '../../pages/projects/model/projectsSlice'
import languageCompliance from '../../pages/language-compliance/model/languageComplianceSlice'
import trademarkInfringements from '../../pages/trademark-infringements/model/trademarkInfringementsSlice'
import team from '../../pages/team/model/teamSlice'
import referrerProgram from '../../pages/referral-program/model/referralProgramSlice'
import { rtkQueryErrorLogger } from './ErrorLogger'

const rootReducer = combineReducers({
  auth,
  app,
  chatAi,
  research,
  competitors,
  keywords,
  adOverview,
  advertiserReport,
  liveSearch,
  liveUncloaking,
  blackhatMonitoring,
  organicResults,
  detailedInfo,
  positionTracker,
  serpPresence,
  ppcCompliance,
  projects,
  languageCompliance,
  trademarkInfringements,
  team,
  referrerProgram,
})

export const store = configureStore({
  devTools: true,
  reducer: {
    root: rootReducer,
    [enhancedApi.reducerPath]: enhancedApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat([
      enhancedApi.middleware,
      rtkQueryErrorLogger,
    ]),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
